// extracted by mini-css-extract-plugin
module.exports = {"slicedTitle":"FormatNotificationMessage_slicedTitle__DQTm-","wrap":"FormatNotificationMessage_wrap__AGcsb"};